import React, { useMemo } from 'react';

import useMergeProps from '../../../../hooks/useMergeProps';
import useTypedSelector from '../../../../hooks/useTypedSelector';
import { getIsFromMultichoiceFromFilterId } from '../../../../types/matchBetFilters';
import { useLineUpMainViewContext } from '../../contexts/LineUpMainViewContext';
import { LineUpPlayerContext } from '../../contexts/LineUpPlayerContext';

import LineUpPlayer from './LineUpPlayer';
import makeLineUpPlayerPropsSelector from './LineUpPlayer.selector';

type LineUpPlayerContainerProps = {
  className?: string;
  playerId: number;
  isGoalKeeper?: boolean;
};

const LineUpPlayerContainer = ({ isGoalKeeper, playerId, ...ownProps }: LineUpPlayerContainerProps) => {
  const { matchId, sportId, filterId, teamId, sliderValue } = useLineUpMainViewContext();
  const isFromMultichoice = useMemo(() => getIsFromMultichoiceFromFilterId(filterId), [filterId]);

  const selectorProps = useMemo(
    () => ({
      matchId,
      sportId,
      teamId,
      filterId,
      playerId,
      isFromMultichoice,
      sliderValue,
    }),
    [matchId, sportId, teamId, filterId, playerId, isFromMultichoice, sliderValue],
  );
  const selector = useMemo(() => makeLineUpPlayerPropsSelector(), []);
  const selectedProps = useTypedSelector((state) => selector(state, selectorProps));

  const forwardedState = useMemo(() => ({ playerId, isGoalKeeper }), [playerId, isGoalKeeper]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return sportId ? (
    <LineUpPlayerContext.Provider value={forwardedState}>
      <LineUpPlayer {...enhancedProps} sportId={sportId} />
    </LineUpPlayerContext.Provider>
  ) : null;
};

export default React.memo<LineUpPlayerContainerProps>(LineUpPlayerContainer);
